import ClosedUserGroupNotification from './ClosedUserGroupNotification/ClosedUserGroupNotification.js'
import enablePageReloadUponAuthentication from './helpers/enablePageReloadUponAuthentication.js'

export { enablePageReloadUponAuthentication, ClosedUserGroupNotification }

export default ClosedUserGroupNotification
